import { slugify } from '@/common';

export function slugForString(string: string): string {
  return slugify(string);
}

export const pluralize = (count: number, singular: string, plural?: string) => {
  if (plural) {
    return count === 1 ? singular : plural;
  }

  return count === 1 ? singular : `${singular}s`;
};
